import {RatingDisplay} from './rating-display.react-component';
import {EnrollmentCount} from '../enrollment-count/enrollment-count.react-component';

import styles from './ratings-with-enrollments.module.scss';
import {useClpCourse} from '../../context/clp-course-provider.react-component';
import {useFeatures} from '@udemy-v2/react-experimentation';
import {COURSE_VARIATION_FEATURE_CODE, getCourseVariationFeatureConfig} from '../../utils/feature';
// EXPERIMENT: Remove useCourseRating and skeleton imports when course variations experiment concludes
import {useCourseRating} from '../../hooks/use-course-rating';
import {Block, Skeleton} from '@udemy-v2/react-reveal-components';

interface RatingsWithEnrollmentsProps {
    hideRating?: boolean;
    hideEnrollments?: boolean;
    numeric?: boolean;
}

export const RatingsWithEnrollments = ({
    hideRating,
    hideEnrollments,
    numeric,
}: RatingsWithEnrollmentsProps) => {
    const {enrollments, variationAggregation, isInGooglePartnerCollection} = useClpCourse();
    const {featureVariantAssignments} = useFeatures([COURSE_VARIATION_FEATURE_CODE]);
    const hasVariations = !!variationAggregation?.variations.length;
    const isRatingsDisclaimerEnabled =
        getCourseVariationFeatureConfig(featureVariantAssignments)?.cv_ui_ratings_disclaimer ===
        true;
    const showEnrollments = !isInGooglePartnerCollection && !hideEnrollments;
    const {rating, isLoading} = useCourseRating();

    // EXPERIMENT: Skeleton loading state for client-side rating refetch
    if (!hideRating && isLoading) {
        return (
            <span className={styles['ratings-with-enrollments']}>
                <span>
                    <Skeleton>
                        <Block className={styles['rating-skeleton']} />
                    </Skeleton>
                </span>
                <span>
                    {showEnrollments && enrollments?.count && (
                        <EnrollmentCount count={enrollments.count} />
                    )}
                </span>
            </span>
        );
    }

    return (
        <span className={styles['ratings-with-enrollments']}>
            <span>
                {!hideRating && rating !== null && rating !== undefined && (
                    <RatingDisplay
                        average={rating?.average ?? 0}
                        count={rating?.count ?? 0}
                        numeric={numeric}
                        isAggregated={hasVariations && isRatingsDisclaimerEnabled}
                    />
                )}
            </span>
            <span>
                {showEnrollments && enrollments !== null && enrollments !== undefined && (
                    <EnrollmentCount count={enrollments?.count ?? 0} />
                )}
            </span>
        </span>
    );
};
